import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import * as $ from "jquery";

@Component({
	selector: 'app-write',
	templateUrl: './write.component.html',
	styleUrls: ['./write.component.css']
})
export class WriteComponent implements OnInit {

	frm : FormGroup;
	frm2 : FormGroup;

	logi_user:any;
	type:any;
	data:any = [];
	addrList:any = "";
	skeyword:any;
	keywordS:any = "";
	keywordLatest:any = [];
	historyCnt:number = 0;
	keywordHistory:any = [];
	keywordHistory2:any = [];
	keywordHistory3:any = [];
	keywordHistory4:any = [];
	keywordHistory5:any = [];
	keywordHistory6:any = [];
	keywordHistory7:any = [];
	keywordHistory8:any = [];

	passData:any = [];

	total_cnt:any = 0;

	partnerList:any;

	viewTxt:any;

	@ViewChild('search') search;

	constructor(
		private http: HttpClient,
		private router: Router,
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public getData,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {

		this.type = this.getData['type'];

		if( this.type == "start" )
		{
			this.viewTxt = "출발지";
		}
		else
		{
			this.viewTxt = "도착지";
		}

		this.frm = new FormGroup({
			recom: new FormControl(''),
			redepart: new FormControl(''),
			rename: new FormControl('', Validators.required),
			retel: new FormControl('', [Validators.required, Validators.minLength(10)]),
			readdr1: new FormControl('', Validators.required),
			readdr2: new FormControl(''),
			readdrroad: new FormControl(''),
			rexpoint: new FormControl('', Validators.required),
			reypoint: new FormControl('', Validators.required),
			resido: new FormControl('', Validators.required),
			regugun: new FormControl('', Validators.required),
			resdong: new FormControl('', Validators.required),
			memo: new FormControl(''),
		});

		this.frm2 = new FormGroup({
			search: new FormControl('', Validators.required),
		});
	}

	ngOnInit() {
		if( this.getData['name'] )
		{
			this.frm.get('rename').setValue( this.getData['name'] );
			this.frm.get('retel').setValue( this.getData['tel'] );
			this.frm.get('recom').setValue( this.getData['com'] );
			this.frm.get('redepart').setValue( this.getData['depart'] );
			this.frm.get('readdr1').setValue( this.getData['addr1'] );
			this.frm.get('readdr2').setValue( this.getData['addr2'] );
			this.frm.get('readdrroad').setValue( this.getData['road'] );
			this.frm.get('rexpoint').setValue( this.getData['xpoint'] );
			this.frm.get('reypoint').setValue( this.getData['ypoint'] );
			this.frm.get('resido').setValue( this.getData['sido'] );
			this.frm.get('regugun').setValue( this.getData['gugun'] );
			this.frm.get('resdong').setValue( this.getData['dong'] );
			this.frm.get('memo').setValue( this.getData['memo'] );
		}
	}

	ngAfterViewInit() {

		this.getPartnerList();
		this.keywordGet();
	}

	async applyInfo() {
		this.passData['type'] = this.type;
		this.passData['name'] = this.frm.get('rename').value;
		this.passData['tel'] = this.frm.get('retel').value;
		this.passData['com'] = this.frm.get('recom').value;
		this.passData['depart'] = this.frm.get('redepart').value;
		this.passData['addr1'] = this.frm.get('readdr1').value;
		this.passData['addr2'] = this.frm.get('readdr2').value;
		this.passData['road'] = this.frm.get('readdrroad').value;
		this.passData['xpoint'] = this.frm.get('rexpoint').value;
		this.passData['ypoint'] = this.frm.get('reypoint').value;
		this.passData['sido'] = this.frm.get('resido').value;
		this.passData['gugun'] = this.frm.get('regugun').value;
		this.passData['dong'] = this.frm.get('resdong').value;

		this.dialogRef.close({
			event: 'close',
			data: this.passData
		});
	}

	async getPartnerList() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/partner.list.php', formData).subscribe((response) => {
			this.partnerList = response['list'];

			this.total_cnt = response['total_cnt'];
		});
	}

	async getPartnerInfo(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/partner.data.php', formData).subscribe((response) => {
			this.frm.get('rename').setValue( response['data']['name'] );
			this.frm.get('retel').setValue( response['data']['tel'] );
			this.frm.get('recom').setValue( response['data']['com'] );
			this.frm.get('redepart').setValue( response['data']['depart'] );
			this.frm.get('readdr1').setValue( response['data']['addr1'] );
			this.frm.get('readdr2').setValue( response['data']['addr2'] );
			this.frm.get('readdrroad').setValue( response['data']['road'] );
			this.frm.get('rexpoint').setValue( response['data']['xpoint'] );
			this.frm.get('reypoint').setValue( response['data']['ypoint'] );
			this.frm.get('resido').setValue( response['data']['sido'] );
			this.frm.get('regugun').setValue( response['data']['gugun'] );
			this.frm.get('resdong').setValue( response['data']['dong'] );
			this.frm.get('memo').setValue( response['data']['memo'] );
		});
	}

	openLayer(i) {
		var a = i - 1;

		$(".tab-ibox li a").removeClass("curr");
		$(".tab-ibox li:eq("+a+") a").addClass("curr");
		$(".layer-box").addClass("dn");
		$("#lay"+i).removeClass("dn");

		if( i == 2 )
		{
			this.search.nativeElement.focus();
		}
	}

	searchAddr() {
		if( this.frm2.get('search').value.length >= 2 )
		{
			setTimeout(() => {
				this.http.get(this.env.API_URL + 'api/address.php?keyword='+this.frm2.get('search').value).subscribe((response) => {
					this.addrList = response['addrList'];
				});
			}, 500);
		}
	}

	selAddr(addr:any, addr2:any, sido:any, gugun:any, dong:any, xpoint:any, ypoint:any, road:any){
		var getKeyword = localStorage.getItem('logiAddrKeyword');

		Promise.all([getKeyword]).then((arrayOfResults) => {
			this.skeyword = String(arrayOfResults[0]);
			var raddr = addr+","+addr2+","+sido+","+gugun+","+dong+","+xpoint+","+ypoint;
			this.keywordS = raddr+"|"+this.skeyword;

			localStorage.setItem('logiAddrKeyword', this.keywordS);
		});

		this.frm.get('readdr1').setValue(addr2);
		this.frm.get('rexpoint').setValue(xpoint);
		this.frm.get('reypoint').setValue(ypoint);
		this.frm.get('resido').setValue(sido);
		this.frm.get('regugun').setValue(gugun);
		this.frm.get('resdong').setValue(dong);
		this.frm.get('readdrroad').setValue(road);
	}

	keywordGet() {
		var getKeyword = localStorage.getItem('logiAddrKeyword');

		Promise.all([getKeyword]).then((arrayOfResults) => {
			this.skeyword = String(arrayOfResults[0]);

			var ss = this.skeyword.split("|");
			var re_data = Array();

			$.each(ss, function(i,value){
				if( value != "" )
				{
					if(re_data.indexOf(value) == -1 ){
						re_data.push(value);
					}
				}
			});

			re_data = re_data.filter(function(item) {
				return item !== null && item !== undefined && item !== '';
			});

			var g = 0;
			var sdata = "";
			//this.historyCnt = re_data.length;
			for( var i=0; i<re_data.length; i++ )
			{
				if( re_data[i] != "" && re_data[i] != null && re_data[i] != undefined )
				{
					if( re_data[i] )
					{
						this.keywordLatest[g] = re_data[i];
						sdata = sdata+"|"+re_data[i];
						g++;
					}
				}
			}

			this.keywordLatest = this.keywordLatest.filter(function(item) {
				return item !== null && item !== undefined && item !== '';
			});

			var a = 0;
			for( var j=0; j<this.keywordLatest.length; j++ )
			{
				var st = this.keywordLatest[j].split(",");
				if( st[1] != "" && st[1] != undefined )
				{
					this.keywordHistory[a] = st[0];
					this.keywordHistory2[a] = st[1];
					this.keywordHistory3[a] = st[2];
					this.keywordHistory4[a] = st[3];
					this.keywordHistory5[a] = st[4];
					this.keywordHistory6[a] = st[5];
					this.keywordHistory7[a] = st[6];
					this.keywordHistory8[a] = st[7];
					a++;
				}
			}
			this.historyCnt = a;

			sdata = sdata.substr(1, sdata.length);

			localStorage.setItem('logiAddrKeyword', sdata);
		});
	}

	keywordAllDel()
	{
		var getKeyword = localStorage.setItem('logiAddrKeyword', '');
		this.keywordLatest = Array();
		this.historyCnt = 0;
		$("#latest-box .addr-ibox").remove();
	}

	resetForm() {
		this.frm.reset();
	}

	movePartner() {
		this.router.navigate(['/partner']);
		this.closeWrite();
	}

	async closeWrite() {
		this.dialogRef.close();
	}
}
